// resolve custom component hook beforeRouteReady
export async function resolveBeforeRouteReady(to, from, next) {
  // Get first route, means page route
  const currentRoute = to.matched[0];
  // Get component for this route
  const pageComponent = currentRoute?.components?.default;
  // Check if this component has beforeRouteReady hook
  if (!pageComponent || typeof pageComponent.beforeRouteReady !== 'function') return;
  // Call hook with params and next attribute as resolve for promise
  const newRoute = await new Promise(resolveHook => (
    pageComponent.beforeRouteReady(to, from, resolveHook)
  ));
  // If new route called
  if (newRoute) {
    // Pass it to next
    next(newRoute);
    throw new Error(`redirect by beforeRouteReady hook in ${pageComponent.name} component`);
  }
}
